const createCopyByPickingPropsFromObject = (objectToCopy, keyFields) => {
  const newObject = {};
  keyFields.forEach((keyField) => {
    Object.assign(newObject, { [keyField]: objectToCopy[`${keyField}`] });
  });
  return newObject;
};

const getArrayOfCopiedObjects = (arrayOfObjects, keyFieldsToCopy) => (arrayOfObjects.map((object) =>
  createCopyByPickingPropsFromObject(object, keyFieldsToCopy)));

const createObjectWithPreferredKeysFromArrayOfObjects = (
  arrayOfObjects,
  keyField,
) =>
  arrayOfObjects.reduce((object, element) => {
    object[element[keyField]] = element;
    return object;
  }, {});

const createMapFromObject = (object) => new Map(Object.entries(object));

const getArrayOfItemsFromMapByRefKeys = (arrayOfRefKeys, mapOfObjects) =>
  arrayOfRefKeys.reduce((arrayOfObjects, refKey) => {
    arrayOfObjects.push(mapOfObjects.get(refKey));
    return arrayOfObjects;
  }, []);

export {
  createCopyByPickingPropsFromObject,
  getArrayOfCopiedObjects,
  createObjectWithPreferredKeysFromArrayOfObjects,
  getArrayOfItemsFromMapByRefKeys,
  createMapFromObject,
};
